"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTypes = void 0;
var MessageTypes;
(function (MessageTypes) {
    MessageTypes["ALL"] = "ALL";
    MessageTypes["BROADCAST"] = "BROADCAST";
    MessageTypes["PRIVATE"] = "PRIVATE";
})(MessageTypes = exports.MessageTypes || (exports.MessageTypes = {}));
//# sourceMappingURL=MessageTypes.js.map